export const HIDDEN_ELEMENT_CLASS = "hidden-element";
export const MAX_MOBILE_WIDTH_IN_PIXELS = 768;
export const THREE_SECONDS_IN_MILLISECONDS = 3 * 1000;
export const ONE_MINUTE_IN_MILLISECONDS = 60 * 1000;
export const THREE_MINUTES_IN_MILLISECONDS = 3 * 60 * 1000;
